<template>
  <el-select
    :model-value="modelValue"
    :placeholder="placeholder"
    class="w-[400px]"
    size="large"
    filterable
    popper-class="select-custom-popper select-popper-v2 w-[400px]"
    :remote="remote"
    :remote-show-suffix="remote"
    :remote-method="remoteMethod"
    clearable
    @change="onChange"
    @visible-change="onVisibleChange"
    :loading="loading"
    :disabled="disabled"
  >
    <el-option
      v-for="item in options"
      :key="getKey(item)"
      :label="getLabel(item)"
      :value="getValue(item)"
    >
      <span :style="{ lineHeight: showDescription ? '13px' : undefined }">{{ getLabel(item) }}</span>
      <template v-if="showDescription && getDescription(item)">
        <br />
        <span style="font-size: 13px">{{ getDescription(item) }}</span>
      </template>
    </el-option>
  </el-select>
</template>

<script lang="ts" setup>
interface Props {
  modelValue?: string | number;
  placeholder?: string;
  options: any[];
  valueKey?: string;
  labelKey?: string;
  descriptionKey?: string;
  loading?: boolean;
  disabled?: boolean;
  remote?: boolean;
  remoteMethod?: (query: string) => void;
  showDescription?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  placeholder: 'Select',
  valueKey: 'id',
  labelKey: 'name',
  descriptionKey: 'description',
  loading: false,
  disabled: false,
  remote: false,
  showDescription: true,
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | number | undefined): void;
  (e: 'change', value: any): void;
  (e: 'visible-change', visible: boolean): void;
}>();

const getKey = (item: any): string | number => {
  return item[props.valueKey];
};

const getValue = (item: any): string | number => {
  return item[props.valueKey];
};

const getLabel = (item: any): string => {
  const label = item[props.labelKey] || '';
  const desc = item[props.descriptionKey];
  // If showDescription is false but we want combined label
  return desc && !props.showDescription ? `${label} - ${desc}` : label;
};

const getDescription = (item: any): string => {
  return item[props.descriptionKey] || '';
};

const onChange = (value: any) => {
  emit('update:modelValue', value);
  emit('change', value);
};

const onVisibleChange = (visible: boolean) => {
  emit('visible-change', visible);
};
</script>
